<template>
  <div class="ret-cards-wrapper">
    <v-card class="ret-header-card">
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3>
            <v-text-field clearable hide-details solo
              v-model="search"
              :label="$t('search')"
              append-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-autocomplete clearable hide-no-data solo no-filter
              v-model="assetTypeId"
              item-text="name"
              item-value="id"
              :label="$tc('asset-types.entity-name', 1)"
              :items="lazySelect['asset-types'].listItems"
              :search-input.sync="lazySelect['asset-types'].search"
              :loading="lazySelect['asset-types'].loading"
              @focus="updateLazySelect({ model: 'asset-types' })"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 sm4 md3>
             <v-switch v-model="showArchived" input-value="true" :label="$t('archived')" class="mt-2"></v-switch>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <v-card class="ret-card-new">
      <v-card-text>
        <v-data-table :headers="headers"
                      :items="pagedItems"
                      :server-items-length="totalItems"
                      :no-data-text="$t('no-data-available')"
                      :footer-props="{ 'items-per-page-text': $t('rows-per-page'), 'items-per-page-options': [10,20,50,100, { text: $t('all'), value: -1 }] }"
                      :options.sync="options"
                      :loading="loading">

          <template slot="item" slot-scope="props">
            <tr @click="showItemDetail(props.item)">
              <td>
                <v-tooltip bottom v-if="props.item.xHasLocation">
                  <template v-slot:activator="{ on }">
                    <v-btn text icon class="map-icon" v-on="on"
                        @click.stop="$router.push({name: 'city-map', params: {assetId: props.item.id}})">
                      <v-icon>map</v-icon>
                    </v-btn>
                  </template>
                  {{ `Lat: ${props.item.lat.toFixed(3)} | Lon: ${props.item.lon.toFixed(3)}` }}
                </v-tooltip>
              </td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.assetType ? props.item.assetType.name : '' }}</td>
              <td>{{ props.item.deviceType }}</td>
              <td><v-icon>{{ complianceIcon(props.item) }}</v-icon></td>
              <td v-if="props.item.archivedAt">
                <v-btn text icon small :title="$t('restore')" @click.stop="restoreItem(props.item)">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import lazyItems from '../helpers/lazy-items.es6'
import lazySelects from '../helpers/lazy-selects.es6'

export default {
  name: 'assets',
  mixins: [lazyItems, lazySelects],
  data () {
    return {
      model: {
        name: 'reports/compliance-report',
        searchColumns: ['name']
      },
      defaultHeaders: [
        { text: this.$t(''), value: 'hasMap', align: 'left', sortable: false },
        { text: this.$t('name'), value: 'assets.name', align: 'left', sortable: true },
        { text: this.$tc('asset-types.entity-name', 1), value: 'assetTypes.name', align: 'left', sortable: true },
        { text: this.$t('devices.type'), value: 'assets.deviceType', align: 'left', sortable: true },
        { text: this.$t('checklists.result'), value: 'checklistResult', align: 'left', sortable: false }
      ],
      autocomplete: [
        { model: 'asset-types', value: 'assetTypeId' }
      ],
      assetTypeId: null
    }
  },

  methods: {
    complianceIcon (item) {
      return item.checklistResult ? 'check' : 'clear'
    },

    async fetchItems () {
      try {
        const { name: model, searchColumns } = this.model
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        const params = {
          limit: itemsPerPage,
          offset: page * itemsPerPage - itemsPerPage
        }

        if (sortBy.length) {
          params.sort = `${sortBy[0]}+${sortDesc[0] ? 'DESC' : 'ASC'}`
        }

        if (this.search) {
          params.search = searchColumns.map(column => `assets.${column}+${this.search}`).join()
          params.searchMode = 'OR'
        }

        if (this.assetTypeId) {
          params.filter = `assets.assetTypeId+${this.assetTypeId}`
        }

        if (this.showArchived) {
          params.archive = true
        }

        const { items, total } = await this.$store.dispatch('lazyItems/getItems', { model, params })

        return Promise.resolve({
          items,
          total
        })
      } catch (error) {
        return Promise.reject(error)
      }
    },

    showItemDetail (item) {
      if (item.archivedAt) return // won't show

      this.$router.push({ name: `assets/id`, params: { id: item.id } })
    }
  },
  watch: {
    assetTypeId () {
      this.updateIndex()
    }
  }
}
</script>
